import React from 'react'
import styled from "styled-components"
import { sizes, breakpoints, colors, fonts } from "../css-variables"
import Button from '../parts/Button'
import brandIcon from '../../../static/assets/WAA_BrandVideo_Animation.gif'


const PageSection = ({className, buttonsAlt }) => {

  return (
    <div className={className}>
      <div className="headingWrapper">
        <h2>Feel What It’s Like to Badger On</h2>
      </div>
      <img src={brandIcon} alt="movie slate icon" className="movie-slate-icon" />
      <Button link="/about/#video" text="Watch the New Video" alt={buttonsAlt} />
      <p className="excerpt">To Badger On is to continue your UW journey — wherever you live and whatever your life stage. And the Wisconsin Alumni Association (WAA) is here for you, and for all alumni and friends, when you want to tap into the best of being a Badger.</p>
      <p className="excerpt">Don’t take our word for it. <a href="/about/#video">Get a real feel for what the experience is like</a> and see yourself in WAA.</p>
    </div>
  )
}

const StyledIntroPageSection = styled(PageSection)`
  position: relative;
  text-align: center;
  color: ${colors.titleWhite};
  background-color: ${colors.badgerRed};
  padding: 58px 36px;
  .movie-slate-icon{
    width: 140px;
    margin-left: 36px;
  }

  .excerpt {
    font-size: ${sizes.s18};
    line-height: ${sizes.s28};

    @media screen and ${breakpoints.laptopS} {
      font-size: ${sizes.s22};
      line-height: ${sizes.s35};
    }
    max-width: 896px;
    margin: 24px auto 12px auto;
    padding: 0;
    a{
      color: white;
      font-weight: 500;
    }

    @media screen and ${breakpoints.laptopS} {
      font-size: ${sizes.s32};
      line-height: ${sizes.s50};
    }
  }
  .headingWrapper {
    position: relative;
    padding-bottom: ${sizes.s32};
    margin-bottom: ${sizes.s32};
    h1,
    h2 {
      color: ${colors.titleWhite};
      font-family: ${fonts.eaves};
      font-weight: bold;
      font-style: italic;
      font-size: ${sizes.s36};
      line-height: ${sizes.s40};
      margin: 0;
      padding: 0 1em;

      @media screen and ${breakpoints.laptopS} {
        font-size: ${sizes.s42};
        line-height: ${sizes.s52};
        padding: 0;
      }
      &:after {
        position: absolute;
        bottom: 0;
        right: calc(50% - ${sizes.s34});
        height: ${sizes.s8};
        width: calc(${sizes.s34} * 2);
        background-color: ${colors.titleWhite};
        content: "";
      }
    }
  }

`
export default StyledIntroPageSection
